<script>
import {mapState} from "vuex";

export default {
  data() {
    return {
      showScrollTop: false,
      scrollHandler: null,
    }
  },
  computed: {
    ...mapState(['isFreeUser','msisdn']),
  },
  methods: {
    backProfile() {
      const hasMsisdn = localStorage.getItem('msisdn') || sessionStorage.getItem('msisdn');

      this.$router.push(hasMsisdn ? '/profile' : '/login')
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onScroll() {
      this.showScrollTop = window.scrollY > 400
    },
  },
  mounted() {
    this.scrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.scrollHandler, { passive: true })
    window.scrollTo({ top: 0 })
  },
  beforeUnmount() {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
  },
}

</script>

<template>

  <div class="tc-page">
    <main class="tc-main">
      <article class="tc-card">

        <div class="tc-logo-wrap">
          <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')" class="tc-logo" alt="logo" />
        </div>

        <h1 class="tc-title text-center">Terms &amp; Conditions</h1>

        <div class="tc-body">

        <p>A. The following Terms and Conditions contain assumptions of risk and/or liability by
          Customers and limit and exclude liabilities, obligations and legal responsibilities which
          Mobile Telephone Networks Proprietary Limited (“MTN”) will have towards Customers and
          other persons.</p>
        <p>B. These Terms and Conditions also limit and exclude Customers rights and remedies
          against MTN and place various risks, liabilities, obligations and legal responsibilities on
          the Customer.</p>
        <p>C. These Terms and Conditions may result in Customers being responsible for paying
          additional costs and amounts and MTN may also have claims and other rights against the
          Customer.</p>
        <p>D. To the extent that the Terms and Conditions or any goods or services provided under the
          Terms and Conditions are governed by the Consumer Protection Act, 2008 (the
          &quot;Consumer Protection Act&quot;), no provision of the Terms are intended to contravene the
          applicable provisions of the Consumer Protection Act, and therefore all provisions of the
          Terms and Conditions must be treated as being qualified, to the extent necessary, to
          ensure that the applicable provisions of the Consumer Protection Act are complied with.</p>
        <p>E. The Customer must read these Terms and Conditions. The use of this product/service will
          constitute an agreement to comply with these Terms and Conditions.</p>
        <p>F. Please pay special attention to all the clauses. Please note that these Terms and
          Conditions must be read together with the standard MTN Internet product and service
          Terms and Conditions and the Penrose Systems Privacy Notice in clause 11 below.</p>

        <h2>1. Introduction</h2>
        <p>1.1 MTN customers who use the Mzansi Rhythm promotions over the promotion
          period stand a chance to win their share of R396 000 (three hundred and ninety-
          six thousand rand) in airtime prizes. MTN Mzansi Rhythm is a subscription service
          that allows users to play a Trivia Music Game for R5 per day, R35 per week or R45
          per month (which are subject to change) (“the Promotional Offer”).</p>

        <h2>2. Duration</h2>
        <p>2.1 This Promotion is available from the 1st of May 2026 until 31st of March 2027 both days inclusive. ("Promotional
          Period").</p>
        <p>2.2 For the duration of the Promotion Period, daily competitions will be hosted.</p>
        <p>2.3 Notwithstanding the Promotion Period, MTN may, in its sole and absolute
          discretion, amend the duration of the Offer Period to a shorter or longer period, or
          withdraw the offer in its entirety, with notice to you. Visit <a href="www.mtn.co.za">www.mtn.co.za</a> or *123#
          for notices, updates and/or changes to services.
        </p>

        <h2>Game Play</h2>
        <table>
          <tr>
            <th>Start Date</th>
            <td>1st of May 2026</td>
          </tr>
          <tr>
            <th>End Date</th>
            <td>31st of March 2027</td>
          </tr>
          <tr>
            <th>Prizes</th>
            <td>Users will be awarded airtime based on the outcome of their gameplay in daily competitions.</td>
          </tr>
        </table>

        <h2>3. Who is Eligible?</h2>
        <ul>
          <li>3.1 Only entries received during the promotional period will qualify to enter the daily
            competition.
          </li>
          <li>3.2 To be eligible the customer must do the following:</li>
          <ul>
            <li>3.1.1. be a South African citizen.</li>
            <li>3.1.2. be residing in South Africa.</li>
            <li>3.1.3. be a natural person.</li>
            <li>3.1.4. be 18 years or older.</li>
            <li>3.1.5. be an MTN subscriber (PayAsYouGo, TopUp or Contract)</li>
            <li>3.1.6. subscribe to Mzansi Rhythm at R5.00 per day, R35 per week or R45 per
              month.
            </li>
            <li>3.1.7. participate and answer the question set out in Mzansi Rhythm daily
              competitions correctly, thereby earning coins.
            </li>
          </ul>
        </ul>

        <h2>4. Prizes</h2>
        <p>4.1 <strong>Rewards:</strong></p>
        <p>Total annual prize pool: R396 000 (three hundred and ninety-six thousand rand), R33 000 (thirty-three thousand
          rand) monthly as detailed in the table below:</p>

        <table>
          <tr>
            <th>Details of Prizes</th>
            <th>Monthly</th>
          </tr>
          <tr>
            <td>FREE Mode</td>
            <td>R3 000</td>
          </tr>
          <tr>
            <td>VIP Mode</td>
            <td>R30 000</td>
          </tr>
          <tr>
            <td><strong>Total</strong></td>
            <td><strong>R33 000</strong></td>
          </tr>
        </table>

        <h2>4.2 Reward type:</h2>
        <p>4.2.1 Voucher-based (redeemable in coupon store)</p>

        <h2>4.3 Prize Delivery:</h2>
        <p>4.3.1 All prizes will be redeemed from the coupon store.</p>
        <p>4.3.2 All risks and ownership of the Prizes shall pass to the winners on
          transfer/delivery thereof and hence all of MTN’s obligations regarding the
          promotion as well as in regard to the Prizes shall terminate.</p>

        <h2>4.4 Random Draws</h2>
        <p>4.4.1 Each coin earned constitutes an entry to the daily draw. If a participant has
          earned 500 (five hundred) coins in the competition, they will have 500 (five
          hundred) entries into the daily draw.</p>
        <p>4.4.2 Winners will be randomly selected daily for the duration of the promotional
          period from all eligible entries who meet all the requirements set out in clause
          3.</p>
        <p>4.4.3 Prize Allocation</p>
        <ul>
          <li><strong>VIP Users:</strong>
            <ul>
              <li>70 winners per day</li>
              <li>Reward: R5 each</li>
            </ul>
          </li>
          <li><strong>Free Users:</strong>
            <ul>
              <li>40 winners per day</li>
              <li>Reward: R2 each</li>
            </ul>
          </li>
        </ul>

        <h2>4.5 Weekly Leaderboard</h2>
        <p>4.5.1 Top 20 on the weekly leaderboard will be determined by the amount of coins earned.</p>
        <p>4.5.2 Coupon pins will be issued weekly to the top 20 on the leaderboard</p>

        <h2>5 How the Service Works</h2>
        <p>5.1 The participant has to play the Online or USSD game that is available on the
          platform which is part of the Mzansi Rhythm service available on *123#,
          *130*692# and/or <a href="http://mzrhythm.com/">http://mzrhythm.com/</a>.
        </p>
        <p>5.2 To use the Service you must join by:</p>
        <ul>
          <li>5.2.1 Dialling *123#, select option 11 on the menu and follow the prompts or by
            dialling *130*692# and following the prompts.
          </li>
          <li>5.2.2 Mzansi Rhythm is a subscription service with FREE and VIP tiers to the game.</li>
          <ul>
            <li>5.2.2.1 You will be eligible to access a limited set of content on the Service free of charge as detailed
              below in clause 6. The VIP service and benefits are only applicable if you subscribe to the subscription
              service for R5.00 (seven Rand) per day, R35 (thirty five Rand) per week or R45 (forty five Rand) per month.
            </li>
            <li>5.2.2.2 You will be charged a subscription fee of R5 (seven Rand) per day, R35 (thirty five Rand) per week
              or R45 (forty-five Rand) per Month (incl. VAT) (the “Fee”) for the relevant period that you remain subscribed
              for the service.
            </li>
          </ul>
        </ul>

        <h2>5.3 Unsubscribing from the service.</h2>
        <p>5.3.1 You may unsubscribe from any of the promoted services by dialling *123#,
          selecting option 8 and selecting the service they would like to unsubscribe
          from.</p>

        <h2>6 Mzansi Rhythm Game Structure</h2>
        <p>6.1 Service Tiers: Mzansi Rhythm offers two tiers of service: Free and VIP:</p>
        <ul>
          <li>6.1.1 Free tier allows 7 (seven) text trivia questions per day on both USSD and Web platforms without needing
            to subscribe. Content is detailed in clause 6.2.1 below.
          </li>
          <li>6.1.2 VIP tier, at a cost of R5 (seven Rand) per day, R35 (thirty five Rand) per week or R45 (forty five Rand)
            per Month and allows 14 (fourteen) questions daily. Content is detailed in clause 6.2.1 and 6.2.2 below.
          </li>
          <li>6.2 Question Categories: Users answer questions from two categories to earn coins:</li>
          <li>
            6.2.1 Music Trivia Text: These are multiple choice music trivia questions in a text
            format, with 1 (one) correct answer and 2 (two) incorrect options.
          </li>
          <li>
            6.2.2 Guess the Song: User listens to a 20-second music track and guess the song
            with 1 (one) correct and 2 (two) incorrect options.
          </li>
        </ul>
        <p>
          Note: USSD players, regardless of their package, can only play text trivia questions. To play
          the other categories, users need to log onto the web service on http://mzrhythm.com.
        </p>
        <p>
          6.3 Bonus Round: At the end of a game session, VIP users, have the opportunity to
          participate in a bonus round without incurring any additional cost. This round
          consists of either two &#39;Guess the Song&#39; questions (web) or two &#39;Music Trivia Text&#39;
          questions (USSD). Getting both questions right will double the session&#39;s coin
          earnings, while incorrect answers will halve them.
        </p>
        <p>
          6.4 Access &amp; Platform:
          Available on USSD and Web on *123#, *130*692# and/or http://mzrhythm.com/
        </p>
        <p>
          6.5 Game Mechanics:
        </p>
        <p>
          6.5.1 On first login, a user profile is created in the service Database.
        </p>
        <p>
          6.5.2 This profile tracks the user’s plays and prizes.
        </p>
        <p>
          6.5.3 SMS notifications may occasionally be sent to users. Preferences can be
          managed in the “My Profile” section.
        </p>
        <p>
          6.5.4 Opt-out: Users can opt-out of these notifications by replying with &quot;stop.&quot;
        </p>
        <h2>
          7 Rica
        </h2>
        <p>
          7.1 In terms of the Amended Regulation of Interception of Communications and
          Provision of Communication-related Information Act 70 of 2002 (“RICA”), you are
          obliged to provide proof of your full names, surname, Identity Document number
          and residential address to a RICA officer when purchasing a SIM card. This is
          necessary to activate you as a customer on the MTN network.
        </p>
        <p>
          7.2 MTN is obliged by law not to activate your SIM card on the MTN network if you
          have not complied with the RICA registration requirements.
        </p>
        <p>
          7.3 By law, if a SIM card is lost, stolen or damaged, you are required to immediately
          notify the South African Police Services in writing. You will also have to
          immediately notify MTN and request the SIM card to be suspended.
        </p>
        <p>
          7.4 If you wish to transfer/sell your SIM card to another person (other than a family
          member), you are required to contact your Service Provider to report such a
          transfer to MTN, and MTN is required by law to deactivate the SIM card. Before
          the new holder of the SIM card can use the SIM card, they must provide proof of
          their full names, surname, Identity Document number and residential address to
          an approved MTN RICA officer to register them as a customer on the MTN
          network. Once they have complied with RICA, and the RICA information is
          received by MTN, MTN will reactivate the SIM card.
        </p>
        <p>
          7.5 If you change ownership to a third party, the Promotional Offer is not transferable.
        </p>
        <p>
          Failure by any person holding/using a SIM card to comply with RICA is an offence.
          Contact your service provider or see <a href="www.mtn.co.za">www.mtn.co.za</a> for details.
        </p>
        <h2>8 Modification of Terms and Conditions</h2>
        <p>
          8.1 MTN reserves the right, at any time, to change, vary, amend or replace these
          Terms and Conditions and any rules relating to this Promotional Offer, its
          promotions, its products and services and to modify its promotions, its products
          and services at its discretion, with notice to you.
        </p>
        <p>
          8.2 See <a href="www.mtn.co.za">www.mtn.co.za</a> for product and services rules and updated Terms and
          Conditions from time to time. Any changes to rules and/or Terms and Conditions
          are effective from the date that they are published on the above-mentioned
          website or elsewhere in any media.
        </p>
        <p>
          8.3 MTN reserves the right at any time to modify, suspend or discontinue the services,
          with notice, without liability to you or any third party. MTN will under no
          circumstance be liable to you for any error, delay, failure or non-availability of the
          service, and you indemnify MTN against any damage or loss you may sustain as a
          result of possession and/or use of the SIM card, MTN network services, or any
          error, delay, failure or non-availability of the service. Visit www.mtn.co.za regularly
          for notice, updates and/or changes to services.
        </p>
        <p>
          8.4 MTN reserves the right from time to time to vary the charges of these services as
          may be deemed necessary in its discretion.
        </p>
        <p>
          8.5 As changes will be posted on www.mtn.co.za, your continued use of the products
          and/or services with the amended rules will be deemed to be accepted by you. It
          is the responsibility of you to review these Terms and Conditions regularly.
        </p>
        <h2>9 Limitation of Liability</h2>
        <p>
          9.1 Subject to the provisions of the Consumer Protection Act, to the extent allowed by
          any other applicable law and also subject to clauses 8.2 and 8.3 below, MTN will
          not be liable to you or to any other person for any loss or damage suffered
          (whether it is direct or indirect):
        </p>
        <p>9.2 if MTN does not supply or deliver any device or SIM card/s on the required date or
          time; or</p>
        <p>9.3 if the MTN network services are interrupted, suspended, or cancelled, for
          whatever reason; or</p>
        <p>9.4 if MTN does not suspend the provision of the MTN network services to you after
          you have specifically requested MTN to do so; or</p>
        <p>9.5 if the loss or damage was caused by any negligent act or failure to act by MTN, its
          employees or agents; or</p>
        <p>9.6 as a result of the use of any device supplied to you by MTN relating to this service.</p>
        <p>9.7 Clause 8.1 does not limit or exclude any warranties or obligations which are
          implied into this service by the Consumer Protection Act (to the extent applicable)
          or which MTN gives under the Consumer Protection Act (to the extent applicable),
          to the extent that the law does not allow them to be limited or</p>

        <h2>10 General</h2>
        <p>10.1 Winners will be updated on the leaderboard on https://mzrhythm.com at the end of
          each tournament date.</p>
        <p>10.2 MTN, their respective directors, affiliates, members, partners, employees, agents,
          consultants, suppliers, contractors, subsidiaries and sponsors assume no liability
          whatsoever for any direct or indirect loss or damage, including but not limited to
          physical harm or death, howsoever arising from or as a result of a person
          receiving the Prize and/or the terms and conditions of this Promotion.
          Furthermore, you will be solely responsible for all products used by you.
          Accordingly, the MTN takes no responsibility for any loss or damage, or any MTN
          airtime associated with the SIM card and/or cell phone number. In the event of
          theft or loss of your cell phone, airtime and/or SIM card, such items must be
          replaced at your own cost, and you are obliged to report such loss or theft to the
          South African Police Services immediately. All persons participating in the
          Promotion hereby expressly indemnify the MTN in this regard and shall hold it
          harmless from all and any claims arising from or as a result of the above reasons.</p>
        <p>10.3 See <a href="www.mtn.co.za">www.mtn.co.za</a> for Promotional Offer rules and updated Terms and
          Conditions from time to time. Any changes to rules and/or Terms and Conditions
          are effective from the date that they are published on the website or elsewhere in
          any media.</p>
        <p>10.4 MTN shall be entitled to terminate the Promotional Offer if any customers are
          involved in any fraudulent activity or suspected fraudulent activity.</p>

        <h2>11 Fanclash Privacy Notice</h2>
        <p>This Privacy Notice is for https://mzrhythm.com/ subscribers. Mzansi Rhythm is owned
          by Fanclash South Africa (Pty) Ltd.</p>
        <p>11.1 WHAT WE COLLECT
           We collect your cell phone number. We don’t collect your billing details. MTN
          charges you directly from your available airtime.
           We collect information about your online activity. This includes your login
          information, how many times you log in, how long and how often you play
          games.</p>
        <p>11.2 HOW WE USE IT
           We’ll send you an SMS to confirm that you are subscribed and when you win
          a prize.
           We’ll display your username on our leader board.
           When you unsubscribe from our service, we may send you direct marketing
          about new games and promotions, but you can opt out anytime.</p>
        <p>11.3 WE DON’T SHARE IT UNLESS WE HAVE TO
           We share your information with MTN to allocate your prizes and collect
          subscription fees.
           We may share your information with service providers to help us manage
          operations, e.g., accountants, auditors, and data storage providers. We only
          share the information that the service provider needs – nothing more.
           We only share your personal information if it is necessary to manage our
          relationship with you or MTN.</p>
        <p>11.4 WE ONLY KEEP IT WHILE WE NEED IT
           We keep your information for as long as we really need it. When you
          subscribe, we’ll keep your cell phone number for as long as you have a profile
          and for 6 months after you unsubscribe from our service, to send you
          information about new games and promotions.</p>
        <p>11.5 WE DO OUR BEST TO PROTECT IT
           We have reasonable security measures in place to protect your personal
          information.
           We check our systems regularly for security issues.</p>
        <p>11.6 YOU CAN MANAGE YOUR INFORMATION
          To exercise any of your rights as listed below, simply email us on
          hello@thefanclash.com.with the subject line of what you would like to
          amend/update or simply tell us what you want to do. Then, we’ll take it from
          there.

           Ask us what we know about you.
           Ask what personal information we share.
           Request access to your record.
           Ask us to update, correct, or delete any personal information we have about
          you.
           Opt out of marketing messages.
           Object to the use of your personal information.
           Complain to the information regulator.

          It may take us up to 21 days to respond because there are procedures we must follow.

          We might ask for additional information to verify your identity and enable us to
          respond to your request successfully.</p>
        <h2>Fraud Prevention and Platform Security</h2>
        <p>To keep our games fair, we use Cloudflare Turnstile to confirm that you are a real person
          and not an automated program. It runs invisibly in the background, so there is nothing for
          you to do. To carry out this check, Cloudflare may process limited technical information about
          your device and browser on our behalf. Cloudflare does not use this information for advertising
          or to track you across other websites. For more detail, see Cloudflare's Turnstile Privacy
          Addendum: <a href="https://www.cloudflare.com/turnstile-privacy-policy">https://www.cloudflare.com/turnstile-privacy-policy</a>.</p>
        <p>While you play, we also collect technical and interaction signals such as answer timing,
          input patterns, and device and browser characteristics to distinguish genuine human play from
          automated cheating. We use this information only to detect and prevent fraud and abuse, in line
          with the Protection of Personal Information Act (POPIA).</p>
        </div>

        <div class="tc-card-footer">
          <button type="button" class="tc-back-btn" @click="backProfile">
            <span class="tc-back-chevron" aria-hidden="true">‹</span>
            <span>Go Back</span>
          </button>
        </div>

      </article>
    </main>

    <button
      type="button"
      class="tc-scroll-top-btn"
      :class="{ 'is-visible': showScrollTop }"
      @click="scrollToTop"
      aria-label="Scroll to top"
    >
      <span aria-hidden="true">↑</span>
    </button>
  </div>

</template>

<style scoped>
/* Mzansi Rhythm Terms & Conditions — yellow-accented card layout,
   mirroring the MTN Uganda (mtn-ug-en) content-page design. */
.tc-page {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(180deg, #faf9f5 0%, #efeee7 100%);
  display: flex;
  flex-direction: column;
}

.tc-main {
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 16px 12px 32px;
}

.tc-card {
  width: 100%;
  max-width: 760px;
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.06), 0 2px 6px rgba(0, 0, 0, 0.04);
  padding: 22px 18px 14px;
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-top: 4px solid #ffcb05;
  animation: tc-card-rise 360ms cubic-bezier(0.22, 1, 0.36, 1);
  font-family: 'Clash Display', system-ui, -apple-system, sans-serif;
  color: #2b2b30;
  font-size: 14px;
  line-height: 1.7;
}

@keyframes tc-card-rise {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ---------------- header ---------------- */
.tc-logo-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 6px;
}

.tc-logo {
  width: 33%;
  max-width: 150px;
  height: auto;
}

.tc-title {
  font-family: 'Clash Display', system-ui, sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #111114;
  margin: 4px 0 16px;
  line-height: 1.3;
  padding-bottom: 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

/* ---------------- section headings ---------------- */
.tc-body h2 {
  display: inline-block;
  font-family: 'Clash Display', system-ui, sans-serif;
  font-size: 15.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #111114;
  margin: 22px 0 8px;
  padding: 3px 0 5px;
  border-bottom: 2px solid #ffcb05;
  line-height: 1.35;
}

/* ---------------- body ---------------- */
.tc-body p {
  color: #2b2b30;
  margin: 0 0 10px;
}

.tc-body a {
  color: #8a6d00;
  text-decoration: underline;
  word-break: break-word;
}

.tc-body strong,
.tc-body b {
  color: #8a6d00;
}

/* ---------------- lists ---------------- */
.tc-body ul {
  margin: 8px 0;
  padding-inline-start: 18px;
  list-style: none;
}

.tc-body ul li {
  position: relative;
  padding-inline-start: 16px;
  margin-bottom: 6px;
  color: #2b2b30;
}

.tc-body ul li::before {
  content: '';
  position: absolute;
  inset-inline-start: 0;
  top: 0.7em;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #ffcb05;
}

/* nested lists get a lighter dot so hierarchy still reads */
.tc-body ul ul li::before {
  background: #ffe08a;
}

/* ---------------- tables ---------------- */
.tc-body table {
  width: 100%;
  border-collapse: collapse;
  margin: 12px 0 16px;
  font-size: 13.5px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  overflow: hidden;
}

.tc-body th,
.tc-body td {
  text-align: left;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  vertical-align: top;
}

.tc-body th {
  background: #fff6d6;
  color: #111114;
  font-weight: 700;
}

.tc-body tr:last-child th,
.tc-body tr:last-child td {
  border-bottom: none;
}

/* ---------------- return button ---------------- */
.tc-card-footer {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
}

.tc-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ffcb05;
  color: #111114;
  border: none;
  border-radius: 999px;
  padding: 12px 30px;
  font-family: 'Clash Display', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
  box-shadow: 0 6px 14px rgba(255, 203, 5, 0.4);
}

.tc-back-btn:hover {
  transform: translateY(-1px);
  background: #e6b800;
  box-shadow: 0 8px 18px rgba(255, 203, 5, 0.5);
}

.tc-back-btn:active {
  transform: translateY(0);
}

.tc-back-chevron {
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  transform: translateY(-1px);
}

/* ---------------- scroll-to-top fab ---------------- */
.tc-scroll-top-btn {
  position: fixed;
  bottom: 20px;
  inset-inline-end: 18px;
  width: 44px;
  height: 44px;
  border-radius: 999px;
  background: #ffcb05;
  color: #111114;
  border: none;
  font-size: 22px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 22px rgba(255, 203, 5, 0.45);
  opacity: 0;
  pointer-events: none;
  transform: translateY(12px);
  transition: opacity 200ms ease, transform 200ms ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 60;
}

.tc-scroll-top-btn.is-visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
}

.tc-scroll-top-btn:hover {
  background: #e6b800;
}

/* ---------------- responsive ---------------- */
@media (min-width: 640px) {
  .tc-main {
    padding: 28px 16px 48px;
  }
  .tc-card {
    padding: 32px 36px 24px;
    font-size: 15px;
  }
  .tc-title {
    font-size: 26px;
  }
  .tc-body h2 {
    font-size: 17px;
  }
  .tc-scroll-top-btn {
    width: 48px;
    height: 48px;
    bottom: 28px;
    inset-inline-end: 28px;
  }
}
</style>
